<template>
    <!--tab栏-->
    <div>
        <!--填充高度-->
        <div style="height:11vh;"></div>

        <!--主体-->
        <div class="tabbar_body">
            <div v-for="(item,index) in tabbar_list" :key="index" class="every_tab" @click="changeTab(item.url)"> 
                <img :src="choose_index==index?item.icon_xuan:item.icon_wei" style="width:5vw;height:5vw;"> 
                <div v-if="user_type2&&index==1" class="tabbar_font" :style="choose_index==index?'color:#04A9F3;':''">区域看板</div>
                <div v-else class="tabbar_font" :style="choose_index==index?'color:#04A9F3;':''">{{type==1?item.name:item.name2}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    choose_index:{
        type:Number,
        default: 1,
    },
    type:{
        type:Number,
        default: 1, 
    },
    user_type2:{//是否是区域账号
        type:Boolean,
        default:false,
    }
  },
  data() {
    return {
        tabbar_list:[
            {name:'经营分析',name2:'经营分析',url:'form',icon_wei:require('@/assets/tabbar/jingyingfenxi_wei.png'),icon_xuan:require('@/assets/tabbar/jingyingfenxi_xuan.png')},
            {name:'总部看板',name2:'门店看板',name3:'区域看板',url:'home?pagetype=1',icon_wei:require('@/assets/tabbar/zongbukanban_wei.png'),icon_xuan:require('@/assets/tabbar/zongbukanban_xuan.png')},
            // {name:'门店看板',url:'home?pagetype=2',icon_wei:require('@/assets/tabbar/mendiankanban_wei.png'),icon_xuan:require('@/assets/tabbar/mendiankanban_xuan.png')},
            {name:'盘点',name2:'盘点',url:'point',icon_wei:require('@/assets/tabbar/point.png'),icon_xuan:require('@/assets/tabbar/point.png')},
            {name:'我的',name2:'我的',url:'my',icon_wei:require('@/assets/tabbar/wode_wei.png'),icon_xuan:require('@/assets/tabbar/wode_xuan.png')},
        ]
    };
  },
  methods:{
      changeTab(url){
          this.$router.push('./' + url);
      }
  }
}
</script>
<style scoped>
.tabbar_body{
    height: 9vh;
    width: 100vw;
    background-color:#EFEFEF;
    position:fixed;
    bottom: 0;
    left:0;
    z-index: 20;
    display: flex;
    justify-content: space-around;
}
.every_tab{
    width:20vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.tabbar_font{
    font-size:3.2vw;
    margin-top:0.8vh;
}
</style>